// From ISO date to locale
export const isoToLocaleDate = (iso, locale = 'fr-FR') => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString(locale);
};

// Manipulate the date by adding or removing days
export const addDays = (date, days) => {
  const d = new Date(date.valueOf());
  d.setDate(d.getDate() + days);
  return d;
};

// Input to "YYYY-MM-DD" format
export function toDateKey(input) {
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
